import { createContext } from 'react'

export enum AddressType {
  STOS = 'stos',
  ETH = 'eth',
}

export enum DirectionType {
  INPUT = 'input',
  OUTPUT = 'output',
}

export type AddressSwapState = {
  [d in DirectionType]: {
    type: AddressType
    value?: string
  }
}

export const InitialSwapContext: AddressSwapState = {
  [DirectionType.INPUT]: {
    type: AddressType.STOS,
  },
  [DirectionType.OUTPUT]: {
    type: AddressType.ETH,
  },
}

type SwapContextType = {
  state: AddressSwapState;
  setState: React.Dispatch<React.SetStateAction<AddressSwapState>>;
}

export const AddressSwapContext = createContext<SwapContextType>({
  state: InitialSwapContext,
  setState: (s: React.SetStateAction<AddressSwapState>) => { },
})
export const AddressSwapProvider = AddressSwapContext.Provider
